import { useState, useEffect } from "react";
import { uploadloadOneImage } from "../../../tools/uploadImage";
import { uploadOneImageUrl, createAdUrl } from "../../../api/endpoints";
import { useSelector } from "react-redux";
import ImageCropper from "../../../components/imageCropper/ImageCropper";
import { ButtonLoader } from "../../../components/uxCollections/Loaders";
import GenerateAdWithAI from "./GenerateAdWithAI";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const CreateAd = ({ closeModal, updateHasAd, updateRunningAd, updateExpiredAd, userCurrency }) => {
  const [adImage, setAdImage] = useState(null);
  const [uploadImageUrl, setUploadImageUrl] = useState(null);
  const [paymentMode, setPaymentMode] = useState("card");
  const [time, setTime] = useState("6");
  const [total, setTotal] = useState(0);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isadvertAiGenerated, setIsadvertAiGenerated] = useState(false); // [false, true]
  const [showImageCropper, setShowImageCropper] = useState(false);
  const [showGenerateAdWithAIModal, setShowGenerateAdWithAIModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //

  const { store } = useSelector((state) => state.store);

  useEffect(() => {
    console.log("new time", time);

    setTotal(time * 100);
  }, [time]);

  useEffect(() => {
    if (adImage && uploadImageUrl && paymentMode && time && total) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [adImage, uploadImageUrl, paymentMode, time, total, isFormValid]);

  const handlePaymentMode = (e) => {
    let target = e.target;
    Array.from(target.parentNode.children).forEach((item) => {
      item.classList.remove("selectedPaymMode");
    });
    target.classList.add("selectedPaymMode");
  };

  const handleModal = (e) => {
    if (e.target === e.currentTarget) {
      closeModal(false);
    }
  };
  const handleUpload = async (e) => {
    /*  let { imageUrl } = await uploadloadOneImage(
      e,

      setAdImage,
      uploadOneImageUrl + store._id + "/StoreAdvertisementImages/" + "AvertisementImage" + "/",
      "AvertisementImage"
    );
    console.log(imageUrl);
    setUploadImageUrl(imageUrl); */
    setIsadvertAiGenerated(false);
    const image = e.target.files[0];
    setAdImage(image);
    if (image) {
      const reader = new FileReader();
      reader.onload = function (evt) {
        setUploadImageUrl(evt.target.result);
        setShowImageCropper(true);
      };
      reader.readAsDataURL(image);
    } else {
      uiAlert("no image uploaded failed", "error");
    }
  };

  const createAd = async () => {
    setIsLoading(true);
    let imageToUpload = new FormData();
    imageToUpload.append("AvertisementImage", adImage);

    let response1 = await fetch(uploadOneImageUrl + store._id + "/StoreAdvertisementImages/" + "AvertisementImage" + "/", {
      method: "POST",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      body: imageToUpload,
    });

    if (response1.ok) {
      let { imageUrl } = await response1.json();

      let payload = {
        status: "active",
        adTime: time,
        clicksOnAd: 0,
        adImage: imageUrl,
        adLink: store.storeLink,
        dailyReach: 0,
        views: 0,
        paymentMode,
        totalAmountPaid: total,
      };

      try {
        let response = await fetch(createAdUrl + store._id, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          let { newAd, storeAds } = await response.json();
          console.log(newAd, storeAds);
          updateHasAd(true);
          updateRunningAd(newAd);
          updateExpiredAd(storeAds.filter((item) => item.status === "expired"));
          closeModal(false);
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const createAdWithAIAdvert = async () => {
    let payload = {
      status: "active",
      adTime: time,
      clicksOnAd: 0,
      adImage: uploadImageUrl,
      adLink: store.storeLink,
      dailyReach: 0,
      views: 0,
      paymentMode,
      totalAmountPaid: total,
    };

    try {
      let response = await fetch(createAdUrl + store._id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        let { newAd, storeAds } = await response.json();
        console.log(newAd, storeAds);
        updateHasAd(true);
        updateRunningAd(newAd);
        updateExpiredAd(storeAds.filter((item) => item.status === "expired"));
        closeModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='creatAdDivwrappper' onClick={(e) => handleModal(e)}>
        <div className='createAddiv'>
          <div className='adImagediv'>
            <img
              src={
                uploadImageUrl
                  ? uploadImageUrl
                  : "https://res.cloudinary.com/ebuka1122/image/upload/v1668594398/samples/Ihub-Consumer-App/Rectangle_1644_qqzkco.png"
              }
            />
            <div>
              <button onClick={() => setShowGenerateAdWithAIModal(true)}>AI generated</button>
              <p>
                Add image <input class='inputSelectImage' type={"file"} onChange={(e) => handleUpload(e)} />{" "}
              </p>
            </div>
          </div>
          <p className='adStoreUrl'>Store Url</p>
          <p>{store.storeLink}</p>
          <p className='adStoreUrl'>Time</p>
          <div>
            <select value={time} onChange={(e) => setTime(e.target.value)}>
              <option value={6}>6 hour</option>
              <option value={12}>12 hour</option>
              <option value={24}>24 hour</option>
              <option value={48}>2 day</option>
              <option value={168}>7 day</option>
            </select>
            <p>see price chart</p>
          </div>
          <div className='advertPaymMode'>
            <p>Payment mode: </p>
            <div>
              <button
                onClick={(e) => {
                  handlePaymentMode(e);
                  setPaymentMode("card");
                }}
                className='selectedPaymMode'
              >
                Card
              </button>
              <button
                onClick={(e) => {
                  handlePaymentMode(e);
                  setPaymentMode("mobilePay");
                }}
              >
                MobilePay
              </button>
            </div>
          </div>
          <div>
            <p>Total</p>
            <p>
              {userCurrency} {total}
            </p>
          </div>

          {isFormValid ? (
            isLoading ? (
              <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='payAdfee'>
                <ButtonLoader />
              </button>
            ) : (
              <button onClick={isadvertAiGenerated ? createAdWithAIAdvert : createAd} className='payAdfee'>
                Pay
              </button>
            )
          ) : (
            <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='payAdfee'>
              Pay
            </button>
          )}
        </div>
      </div>
      {showImageCropper && (
        <ImageCropper
          readImageUrl={uploadImageUrl}
          setCroppedImageUrl={setUploadImageUrl}
          setCroppedImageBolb={setAdImage}
          closeModal={setShowImageCropper}
          desiredAspectRatio={1.96}
        />
      )}
      {showGenerateAdWithAIModal && (
        <GenerateAdWithAI
          closeModal={setShowGenerateAdWithAIModal}
          setGeneratedAiAd={setUploadImageUrl}
          setAdImage={setAdImage}
          setIsadvertAiGenerated={setIsadvertAiGenerated}
        />
      )}
    </>
  );
};

export default CreateAd;
